import { type HolisticCategory } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';
import { type AccountSummary } from '../types/HolisticSummary';

interface UseUpdateSpinwheelLoanAccountBody {
    id?: string;
    displayName?: string;
    userId?: string;
    holisticCategory?: HolisticCategory;
    minimumPaymentAmountCents?: number;
    interestRate?: number | null;
    description?: string;
}

const useUpdateSpinwheelLoanAccount = requestBuilder.mutation<
    AccountSummary,
    UseUpdateSpinwheelLoanAccountBody
>({
    endpoint: () => '/api/spinwheel/liabilities/loan',
    method: 'PATCH',
});

export default useUpdateSpinwheelLoanAccount;
